import { themeColors } from 'themes/clients/baseTheme';

export const COLOR_MAP = {
  ON_TRACK: { barColor: '#B1E39F', textColor: themeColors.functional['2F8133'] },
  OFF_TRACK: { barColor: '#FCC88B', textColor: themeColors.functional.B96400 },
  AT_RISK: { barColor: '#FD9B9B', textColor: themeColors.functional.C62C02 },
  CLOSED: { barColor: '#666666', textColor: themeColors.common.white },
};

export const INITIATIVE_STATUS_OPTIONS = [
  { label: 'To be Done', value: 'ACTIVE', backgroundColor: '#F2F2F2', color: '#125AA9' },
  { label: 'Completed', value: 'COMPLETED', backgroundColor: '#DBF2D3', color: '#1A5724' },
];

export const INITIATIVE_NOT_FOUND = 'requested task is no longer available';
